export class GetLeads {
    static readonly type = '[Leads] Get';
    constructor(public pageIdex: number, public filterResult: {}) {}
}